
import { formatDate } from '../../../../features/core/utils/date-handlers';
import { Vue, Component, Prop } from 'vue-property-decorator'
import ImagesPreview from '../../../core/components/Generics/Images/ImagesPreview.vue'
import LoadingIndicator from '../../../core/components/Generics/LoadingIndicator.vue'
import { Note } from '../../../../features/typescript/notes/notes';

@Component({
  components: {
    ImagesPreview,
    LoadingIndicator
  }
})
export default class NoteList extends Vue {
  @Prop({ default: false }) deletingNote!: boolean;
  @Prop({ default: false }) loading!: boolean;
  @Prop({ required: true }) notes!: Note[];

  parseDate(date: string): string {
    return formatDate(date, false, false);
  }
}
